export const apiDocsUrl = "/api-docs/pulse.html"
